export default "__VITE_ASSET__B57RTvz9__"